// FILE 32: src/pages/Contact.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import InquiryForm from '../components/contact/InquiryForm';
import './Contact.css';

export default function Contact() {
  const [searchParams] = useSearchParams();
  const tileInterest = searchParams.get('tile') || '';

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact Arden Surfaces | Showroom in Garland, TX</title>
        <meta name="description" content="Visit our showroom at 201 Range Drive, Suite E, Garland TX 75040. Mon–Sat 9am–6pm. Call (214) 677-6811 or email inquiries@ardensurfaces.com." />
        <meta property="og:title" content="Contact Arden Surfaces" />
        <meta property="og:description" content="Showroom at 201 Range Drive Suite E, Garland TX. Request samples, get pricing, or start your project today." />
        <meta property="og:url" content="https://www.ardensurfaces.com/contact" />
      </Helmet>
      {/* Header banner */}
      <section className="contact-hero">
        <h1 className="contact-hero__title">Contact Us</h1>
        <p className="contact-hero__subtitle">
          Have a question, need a sample, or ready to start a project? We'd love to hear from you.
        </p>
      </section>

      {/* Main 2-col layout */}
      <div className="contact-main">
        {/* Left: Form */}
        <InquiryForm initialTileInterest={tileInterest} />

        {/* Right: Contact details */}
        <aside className="contact-details">
          <div className="contact-details__card">
            <h2 className="contact-details__heading">Get in Touch</h2>

            <div className="contact-details__item">
              <span className="contact-details__item-label">Showroom Address</span>
              <span className="contact-details__item-value">
                201 Range Drive, Suite E<br />
                Garland, TX 75040
              </span>
            </div>

            <div className="contact-details__item">
              <span className="contact-details__item-label">Phone</span>
              <span className="contact-details__item-value">
                <a href="tel:+12146776811">(214) 677-6811</a><br /><a href="tel:+12146067371">(214) 606-7371</a>
              </span>
            </div>

            <div className="contact-details__item">
              <span className="contact-details__item-label">Email</span>
              <span className="contact-details__item-value">
                <a href="mailto:inquiries@ardensurfaces.com">inquiries@ardensurfaces.com</a>
              </span>
            </div>

            <div className="contact-details__item">
              <span className="contact-details__item-label">Showroom Hours</span>
              <span className="contact-details__item-value">
                Monday – Saturday: 9 am – 6 pm<br />
                Sunday: Closed
              </span>
            </div>
          </div>

          {/* Google Maps embed */}
          <div className="contact-map">
            <iframe
              title="Arden Surfaces Showroom"
              src="https://maps.google.com/maps?q=201+Range+Drive,+Garland,+TX+75040&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </aside>
      </div>
    </div>
  );
}
